import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";

const DEFAULTS = [
  { n: "500+", l: "TALENTS" },
  { n: "100+", l: "CAMPAIGNS" },
  { n: "50+", l: "BRANDS" },
  { n: "5+", l: "YEARS" },
];

export default function AdminSiteStatsTab() {
  const [stats, setStats] = useState(DEFAULTS);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/site-stats").then((r) => { if (r.data?.stats?.length) setStats(r.data.stats); }).catch(() => {});
  }, []);

  const update = (i, k, v) => setStats((s) => s.map((row, x) => x === i ? { ...row, [k]: v } : row));
  const addRow = () => setStats((s) => [...s, { n: "0+", l: "NEW" }]);
  const removeRow = (i) => setStats((s) => s.filter((_, x) => x !== i));

  const save = async () => {
    setBusy(true);
    try {
      await api.post("/admin/site-stats", { stats });
      toast.success("Homepage stats updated");
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
    setBusy(false);
  };

  return (
    <div className="space-y-4">
      <div className="sv-card p-6">
        <div className="sv-overline mb-1">Homepage Statistics</div>
        <div className="text-xs text-[#8A8478]">Edit the four stat blocks shown on the homepage hero. Changes appear immediately after saving.</div>
      </div>
      <div className="space-y-3">
        {stats.map((s, i) => (
          <div key={i} className="sv-card p-4 grid grid-cols-1 md:grid-cols-[160px,1fr,auto] gap-3 items-center" data-testid={`stat-row-${i}`}>
            <input value={s.n} onChange={(e) => update(i, "n", e.target.value)} placeholder="Number (e.g. 500+)" className="sv-input font-serif-editorial text-2xl" data-testid={`stat-n-${i}`} />
            <input value={s.l} onChange={(e) => update(i, "l", e.target.value.toUpperCase())} placeholder="Label (e.g. TALENTS)" className="sv-input font-mono-label tracking-[0.32em] text-xs" data-testid={`stat-l-${i}`} />
            <button onClick={() => removeRow(i)} className="sv-btn-outline text-xs inline-flex items-center gap-1"><Trash2 size={12} />Remove</button>
          </div>
        ))}
      </div>
      <div className="flex justify-between gap-3">
        <button onClick={addRow} className="sv-btn-outline text-xs inline-flex items-center gap-1"><Plus size={12} />Add Stat</button>
        <button onClick={save} disabled={busy} className="sv-btn-primary inline-flex items-center gap-2" data-testid="stats-save"><Save size={14} />{busy ? "Saving…" : "Save Stats"}</button>
      </div>
    </div>
  );
}
